export default __webpack_public_path__ + "static/media/warning--tanks-crossing--g1.ff076d31.png";